export const makeSubpartnersIdsString = (
  res: { content: { id: number }[] },
  IDlist: number[]
) => {
  res.content &&
    res.content.forEach((item: { id: number }) => IDlist.push(item.id));
  const IDsString = res.content && IDlist.join();
  return IDsString;
};
